/*
*
* File JS per la Single Yacht
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import gallery from 'components/gallery/gallery';
import blockForm from 'components/block-form/block-form';
import sliderListYacht from 'components/yacht/slider-list-yacht';
import cardYacht from 'components/yacht/card-yatch';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './single-yacht.scss';

//--------------------------------------------------------------------//


// CUSTOM FUNCTIONS
//--------------------------------------------------------------------//

function initTabs() {
    const context = document.querySelector('.tab-yacht');
    if(!context) return;

    const headerTabs = context.querySelectorAll('.tab-yacht__head > a');
    const contentTabs = context.querySelectorAll('.tab-yacht__body > div');
    if(!headerTabs || !contentTabs) return;

    headerTabs.forEach(item => {

        item.addEventListener('click' , (e) => {
            e.preventDefault();
            const currentDatTab = item.getAttribute('data-tab');

            if(currentDatTab)  {
                const contentToShow = context.querySelector(`.tab-yacht__content[data-tab='${currentDatTab}']`);
                toggleContentTabs(contentToShow);
                toggleHeader(item);
            }

        })

    });

    function toggleContentTabs(showTab) {
        contentTabs.forEach(item => {
            item.classList.remove('active');
            item.classList.remove('fade-in');
        });
        showTab.classList.add('active');

        setTimeout(() => {
            showTab.classList.add('fade-in');
        }, 50); 
    }

    function toggleHeader(showHeader)
    {
        headerTabs.forEach(item => {
            item.setAttribute('aria-selected', 'false');
            item.classList.remove('active');
        });

        showHeader.classList.add('active');
        showHeader.setAttribute('aria-selected', 'true');
    }
}



// INIT COMPONENTI
//--------------------------------------------------------------------//

window.addEventListener('DOMContentLoaded', (e) =>
{
    gallery();
    initTabs();
    sliderListYacht();
});

//--------------------------------------------------------------------//